function isObject(object: unknown): object is object {
  if (typeof object !== "object") return false;
  if (object === null) return false;

  // Typescript will fail our build if this is not correct, nice way to double check
  const _test: object = object;

  return true;
}

export function hasProp<P extends string, O extends object = object>(
  object: unknown,
  prop: P
): object is O & { [K in P]: unknown };

/**
 * Ensures the give object has the specified prop
 */
export function hasProp(object: unknown, props: string | string[]): boolean {
  if (!isObject(object)) return false;

  // checks that the prop to check is a string
  // and checks if its in the object
  if (typeof props === "string") {
    if (props in object) {
      return true;
    }

    return false;
  }

  let value: unknown = object;

  // loop through the supplied array and check each one
  for (let i = 0; i < props.length; i += 1) {
    const prop = props[i];

    // don't really need this but typescript was complaining, its actually impossible for it to be undefined
    // as our function requires it to be defined..
    // probably because we are not running in strict mode :(
    if (prop === undefined) return false;

    if (!hasProp(value, prop)) return false;

    value = value[prop];
  }

  return true;
}
